import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/BackButton';
import RateLimitModal from '../../components/RateLimitModal';
import api from '../../services/api';
import './UtilityPage.css';

const QrCodeGenerator = () => {
  const { isAuthenticated } = useAuth();
  const [text, setText] = useState('');
  const [size, setSize] = useState(300);
  const [qrCode, setQrCode] = useState('');
  const [error, setError] = useState('');
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
  const [rateLimitError, setRateLimitError] = useState(null);

  const handleGenerate = async () => {
    if (!text.trim()) {
      setError('Please enter text for QR code');
      return;
    }

    try {
      setError('');
      const response = await api.post('/api/utilities/qr/generate', { text, size });
      setQrCode(response.data.qrCode);
    } catch (err) {
      if (err.response?.status === 429) {
        const errorData = err.response.data;
        setRateLimitError({
          message: errorData.message || 'Rate limit exceeded',
          isAuthenticated: errorData.isAuthenticated !== undefined ? errorData.isAuthenticated : isAuthenticated,
          suggestion: errorData.suggestion || '',
          currentLimit: errorData.currentLimit || '',
          loginLimit: errorData.loginLimit || '',
          premiumLimit: errorData.premiumLimit || ''
        });
        setShowRateLimitModal(true);
      } else {
        setError(err.response?.data?.error || 'Failed to generate QR code');
        setQrCode('');
      }
    }
  };

  return (
    <div className="utility-page">
      <BackButton />
      <div className="utility-container">
        <h1>QR Code Generator</h1>
        <div className="utility-form">
          <div className="input-section">
            <label>Text/URL</label>
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Enter text or URL"
              rows={3}
            />
          </div>
          <div className="input-section">
            <label>Size (pixels)</label>
            <input
              type="number"
              value={size}
              onChange={(e) => setSize(parseInt(e.target.value) || 300)}
              min="100"
              max="1000"
            />
          </div>
          <button onClick={handleGenerate} className="btn-process">Generate QR Code</button>
          {error && <div className="error-message">{error}</div>}
          {qrCode && (
            <div className="output-section">
              <label>QR Code</label>
              <div style={{ textAlign: 'center' }}>
                <img src={qrCode} alt="QR Code" style={{ maxWidth: '100%' }} />
              </div>
            </div>
          )}
        </div>
      </div>
      
      {showRateLimitModal && rateLimitError && (
        <RateLimitModal 
          error={rateLimitError}
          onClose={() => {
            setShowRateLimitModal(false);
            setRateLimitError(null);
          }}
        />
      )}
    </div>
  );
};

export default QrCodeGenerator;

